import { SHIPMENT_STATUS_LABELS, SHIPMENT_STATUS_STYLES } from '@/lib/shipment'
import type { ShipmentStatus } from '@/api/types'

export function ShipmentStatusBadge({ status }: { status: ShipmentStatus }): React.ReactElement {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium ${SHIPMENT_STATUS_STYLES[status]}`}>
      {SHIPMENT_STATUS_LABELS[status]}
    </span>
  )
}
